/*
 * The adapter between sai's product screens (ported from brochure-demo @ 2a7c405)
 * and our Trapezium contract. His control IDs are `<his screen key>.<target>`;
 * ours are `<our screen ID>.<target>`. toTrapezium() swaps the prefix, so his ID
 * tables can be ported nearly verbatim. An ID outside the map throws: a typo
 * must fail loudly, never ship an unmapped ID.
 *
 * His `data-<old>-id|state|view|private` attributes are written as
 * `data-trapezium-id|state|view|private` in the ported markup.
 */

// His screen key -> our screen ID.
export const SCREEN_IDS = {
  'smart-report': 'product.smart-reports',
  'viz-app': 'product.viz-app',
  hospital: 'product.hospital-reports',
  corporate: 'product.corporate',
  whatsapp: 'product.whatsapp',
  intelligence: 'product.intelligence-layer',
};

export function screenIdFor(key) {
  const screenId = SCREEN_IDS[key];
  if (!screenId) throw new Error(`No Trapezium screen for "${key}"`);
  return screenId;
}

export function toTrapezium(id) {
  const dot = id.indexOf('.');
  if (dot < 1) throw new Error(`Not a screen-scoped control ID: "${id}"`);
  return `${screenIdFor(id.slice(0, dot))}${id.slice(dot)}`;
}
